<header id="header" class="fixed-top">
    <div class="container d-flex align-items-center">
  
      <h1 class="logo mr-auto"><a href="index.html">min</a></h1>
      <nav class="nav-menu d-none d-lg-block">
        <ul>
          <li><a href="" [routerLink]="['/']">Home</a></li>
          <li><a href="" [routerLink]="['/login']" routerLinkActive="router-link-active">Login</a></li>
        </ul>
      </nav>
  
      <a href="" [routerLink]="['/register']" routerLinkActive="router-link-active" class="get-started-btn">Register</a>
  
    </div>
  </header>

<div class="container-fluid">
    <div class="row mt-100">
        <div class="col-sm-8 mx-auto">
            <div class="card shadow">
                <div class="card-body py-100 text-center">
                    <h1 class="fs-50">401</h1>
                    <p class="36">Unauthorized</p>
                    <button class="btn btn-outline px-30" [routerLink]="['/login']" routerLinkActive="router-link-active" >Take me back to the home page</button>
                </div>
            </div>
        </div>
    </div>
</div>